const BANGALORE_ROUTE_COPY = {
  Chennai: {
    leaveHero:
      'Book a one-way taxi from Bangalore to Chennai, then edit pickup or drop if you need a tighter address.',
    returnHero:
      'Leave Chennai for Bangalore in a one-way cab. Pickup and drop are set for this inbound leg and stay editable.',
    leaveIntro: [
      'Bangalore to Chennai is an interstate taxi from Karnataka into the Tamil Nadu capital. It is booked as one vehicle for the full run, not as a Bengaluru local hire and not as a stand-in for Coimbatore to Chennai.',
      'Pickup starts as Bangalore. Change it to Bangalore Airport or another mapped point if that is where you will wait. Drop starts as Chennai and can be narrowed to an address or Chennai Airport before you estimate.',
      'There is no Bangalore–Chennai package fare. After Get Fare Estimate, Sedan, SUV and Crysta show totals from the live mapped drive plus the published tariff and driver bata.',
    ],
    returnIntro: [
      'Chennai to Bangalore is the ride into Karnataka, not a rewrite of the outbound Bangalore page. Use it when you are already in Chennai and only need that westbound interstate taxi.',
      'The form opens with Chennai pickup and Bangalore drop. Replace either field for a neighbourhood, airport or hotel. This URL is not a substitute for Chennai to Coimbatore or the dedicated Chennai to Madurai page.',
      'One Way stays selected so you are not holding a return vehicle in Bangalore unless you switch the card to Round Trip.',
    ],
    leaveTravel:
      'You stay in one cab from your Bangalore pickup through to Chennai. Distance and time are mapped live for this direction rather than reused from another city’s catalogue.',
    returnTravel:
      'The return starts in Chennai and continues to Bangalore as its own mapped drive. This page does not copy the outbound kilometre or treat both directions as the same trip.',
    leaveMeta:
      'Book a one-way Bangalore to Chennai taxi with Easy Drop Taxi. Pickup starts in Bangalore, drop in Chennai, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Chennai to Bangalore taxi with Easy Drop Taxi. Pickup starts in Chennai, drop in Bangalore, and both fields stay editable in the existing form.',
    leaveFaqs: [
      {
        question: 'Can I start this Bangalore to Chennai taxi from Bangalore Airport?',
        answer:
          'Yes. Change pickup to Bangalore Airport or another airport address, keep Chennai as drop or edit it, then continue with Get Fare Estimate.',
      },
      {
        question: 'Is this the same as Coimbatore to Chennai?',
        answer:
          'No. Coimbatore to Chennai is a locked Coimbatore catalogue URL. This page is only Bangalore to Chennai. Open the Coimbatore landing if you are actually starting in Coimbatore.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I finish this Chennai to Bangalore taxi at Bangalore Airport?',
        answer:
          'Yes. Keep Chennai as pickup or edit it, change drop to Bangalore Airport if that is where you will alight, then estimate as usual.',
      },
      {
        question: 'Should I use the Bangalore to Chennai page for the return?',
        answer:
          'No. Book Chennai to Bangalore here. The outbound Bangalore page is a different URL with a different pickup default.',
      },
    ],
  },
  Salem: {
    leaveHero:
      'Travel one way from Bangalore to Salem in an Easy Drop Taxi cab, with both locations editable before you search.',
    returnHero:
      'Start in Salem and book a one-way taxi to Bangalore when you are ready to leave Tamil Nadu for Karnataka.',
    leaveIntro: [
      'Bangalore to Salem is a shorter interstate drop from Karnataka onto the main north–south road through Tamil Nadu. Travellers typically want a single vehicle for the full run and a one-way booking so the cab is not held in Salem.',
      'Pickup defaults to Bangalore. Drop defaults to Salem. Type a hotel, Bangalore Airport or another mapped point if that is the actual start or finish. Chinna Salem is a different city-list label — do not use it unless that is truly the drop.',
      'Sample figures on this page appear only after live mapping. They are not a Salem package and they are not taken from a Coimbatore catalogue kilometre.',
    ],
    returnIntro: [
      'Salem to Bangalore is for leaving the highway city toward Karnataka. It is a separate landing page because pickup starts in Salem, not in Bangalore, and the drive is mapped in this direction.',
      'Keep or edit Salem as pickup and Bangalore as drop. Airport drop in Bangalore is a field edit; that name already exists in Easy Drop Taxi’s city list.',
      'Vehicle rates remain the published per-kilometre tariff plus driver bata. Interstate extras such as permit or toll stay as shown on the review screen.',
    ],
    leaveTravel:
      'The outbound taxi runs from Bangalore to Salem as one booked vehicle. Distance and time on this page come from the live map for that pickup and drop.',
    returnTravel:
      'You board in Salem and continue to Bangalore without reusing the outbound map. If mapping is unavailable, use Get Fare Estimate in the booking card.',
    leaveMeta:
      'Book a Bangalore to Salem one-way taxi with Easy Drop Taxi. Use the online form for pickup, drop and a live fare estimate into Tamil Nadu.',
    returnMeta:
      'Book a Salem to Bangalore one-way taxi. Reverse-route defaults are pre-filled for leaving Salem toward Bangalore, and both locations remain editable.',
    leaveFaqs: [
      {
        question: 'Is Chinna Salem the same drop as Salem on this page?',
        answer:
          'No. This landing defaults to Salem. Chinna Salem is a different label in the city list. Change drop only if that is actually where you will alight.',
      },
      {
        question: 'Can I finish at a factory or hotel in Salem?',
        answer:
          'Yes. Drop starts as Salem. Type a more specific mapped address before you estimate.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from a hotel in Salem rather than the city name?',
        answer:
          'Yes. Pickup defaults to Salem but you can type a hotel or another mapped point before you estimate.',
      },
      {
        question: 'Is this the same booking as Bangalore to Salem?',
        answer:
          'No. This page is only the Salem to Bangalore leg. Use the outbound URL when you are leaving Bangalore.',
      },
    ],
  },
};

export const getBangaloreRouteProfile = (place) => BANGALORE_ROUTE_COPY[place] || null;

export const BANGALORE_EXTRA_DESTINATIONS = ['Chennai', 'Salem'];

export const BANGALORE_ROUTE_HUB = 'Bangalore';

export const BANGALORE_PRIORITY_DESTINATIONS = [
  'Coimbatore',
  'Chennai',
  'Madurai',
  'Trichy',
  'Salem',
];
